var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInsuree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t {opacity:0.5;}\r\n\t.st1{fill:#050505;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,11.9c-2,0-3.7-1.4-4-3.3C11,8,11.3,7.5,11.9,7.4c0.5-0.1,1.1,0.2,1.2,0.8c0.2,1,1.1,1.7,2.1,1.7 c1.2,0,2.1-1,2.1-2.1s-1-2.1-2.1-2.1c-0.3,0-0.7,0.1-1,0.2c-0.5,0.3-1.1,0.1-1.4-0.4c-0.3-0.5-0.1-1.1,0.4-1.4 c0.6-0.3,1.2-0.5,1.9-0.5c2.3,0,4.1,1.8,4.1,4.1S17.4,11.9,15.1,11.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22,23.3c-0.6,0-1-0.4-1-1c0-4.3-2.6-7.7-5.9-7.7c-0.2,0-0.5,0-0.7,0.1c-0.5,0.1-1.1-0.3-1.1-0.8 c-0.1-0.5,0.3-1.1,0.8-1.1c0.3-0.1,0.7-0.1,1-0.1c4.4,0,7.9,4.4,7.9,9.7C23,22.9,22.6,23.3,22,23.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,10c-2.6,0-4.6-2.1-4.6-4.6c0-2.6,2.1-4.6,4.6-4.6s4.6,2.1,4.6,4.6C14.7,7.9,12.6,10,10,10z M10,2.7 c-1.5,0-2.6,1.2-2.6,2.6S8.6,8,10,8s2.6-1.2,2.6-2.6S11.5,2.7,10,2.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.1,23.3c-0.6,0-1-0.4-1-1c0-5.1-3.2-9.2-7-9.2c-3.9,0-7,4.1-7,9.2c0,0.6-0.4,1-1,1s-1-0.4-1-1 c0-6.2,4.1-11.2,9-11.2c5,0,9,5,9,11.2C19.1,22.9,18.6,23.3,18.1,23.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsuree);
export default __webpack_public_path__ + "static/media/icon-insuree.165bb901724c8604403c33a219384974.svg";
export { ForwardRef as ReactComponent };